import { render, staticRenderFns } from "./activity-add-edit-question.vue?vue&type=template&id=bb34420e&scoped=true&"
import script from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
export * from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
import style0 from "./activity-add-edit-question.vue?vue&type=style&index=0&id=bb34420e&scoped=true&lang=scss&"
import style1 from "./activity-add-edit-question.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb34420e",
  null
  
)

component.options.__file = "activity-add-edit-question.vue"
export default component.exports